export class Price {
  value: number;

  constructor(price: number) {
    this.value = price;
  }

  public decimalPart(): string {
    if (this.value < 0) {
      return undefined;
    }

    const splitPrice = (this.value + '').split('.');
    if (!splitPrice[1]) {
      return '00';
    }
    return splitPrice[1].length > 1 ? splitPrice[1] : splitPrice[1] + '0';
  }

  public integerPart(): string {
    if (this.value < 0) {
      return undefined;
    }

    const splitPrice = (this.value + '').split('.');
    return splitPrice[0];
  }

  public integerPartNumber(): number {
    if (this.value < 0) {
      return undefined;
    }

    return Math.trunc(this.value);
  }
}
